import './index.css'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App3'

ReactDOM.render(<App />, document.getElementById('root'))
